import { LoadingSpinner } from '@simplywallst/ui-core';
import { ReactNode } from 'react';
import Link from 'redux-first-router-link';
import { tv } from 'tailwind-variants';

type Props = {
  children: ReactNode;
  to: string;
  onClick: () => void;
  isDisabled?: boolean;
  isLoading?: boolean;
  rel?: string;
};

const button = tv({
  base: [
    'no-underline',
    'text-brand-01',
    'text-xs',
    'grid',
    'items-center',
    'place-content-center',
    'justify-between',
    'bg-brand',
    'rounded-x0_75',
    'gap-x1',
    'px-x1_5',
    'h-x5',
    'bg-brand-03-subtle',
    'grid-cols-[auto_auto_auto]',
    'border',
    'border-p-white-100/5',
    'transition-colors',
    'transifion-opacity',
    'hover:bg-p-blue-120/20',
    'focus:outline-dashed',
    'focus:outline-1',
    'focus:outline-offset-[3px]',
    'focus:outline-p-blue-100',
  ],
  variants: {
    isDisabled: {
      true: 'pointer-events-none cursor-not-allowed opacity-40',
    },
  },
});

export const NarrativeCommunityListPaginationButton = ({
  to,
  children,
  onClick,
  isDisabled,
  isLoading,
  rel,
}: Props) => {
  const [pathname, _hash] = to.split('#');
  return (
    <Link
      aria-disabled={isDisabled}
      to={pathname}
      tabIndex={isDisabled ? -1 : 0}
      onClick={(e) => {
        /**
         * Prevent the default behavior of the link.
         * Due to redux-first-router-link not supporting #hash links, we need to prevent the default behavior
         * and trigger pushState manually. https://github.com/faceyspacey/redux-first-router-link/issues/82
         * This library has long been deprecated and there is no plan to replace this library until next.js lands.
         * We still need to keep 'to' prop for SEO purposes.
         */
        e.preventDefault();
        if (isDisabled) return;

        history.pushState(null, '', to);
        onClick();
      }}
      className={button({ isDisabled })}
      rel={rel}
    >
      {children}
      {isLoading && (
        <LoadingSpinner aria-label="Loading indicator" styleType="light" />
      )}
    </Link>
  );
};
